<template>
  <v-app class="main-cont">
    <AppBar v-if="user"/>
    <SnackBar/>
    <router-view></router-view>
  </v-app>
</template>

<script>
import AppBar from './components/AppBar.vue'
import SnackBar from './components/SnackBar.vue'
export default {
  name: 'App',
  components: {
    SnackBar,
    AppBar
  },
  watch: {
    '$route' () {
      this.user = localStorage.getItem('BVtoken')
    }
  },
  data () {
    return {
      loading: false,
      user: null
    }
  },
  created () {
    this.user = localStorage.getItem('BVtoken')
    const APP_VERSION = process.env.VUE_APP_VERSION

    const savedVersion = localStorage.getItem('app_version')

    if (savedVersion !== APP_VERSION) {
      console.log('tessssssssssssst')
      localStorage.removeItem('BVtoken')
      localStorage.setItem('app_version', APP_VERSION)
    }
  }
}
</script>

<style>
  input {
    outline: none;
  }
  .tabs {
    margin-top: 20px;
    transform: translateY(-5px);
  }
  .theme--light.v-tabs > .v-tabs-bar .v-tab:not(.v-tab--active), .theme--light.v-tabs > .v-tabs-bar .v-tab:not(.v-tab--active) > .v-icon, .theme--light.v-tabs > .v-tabs-bar .v-tab:not(.v-tab--active) > .v-btn, .theme--light.v-tabs > .v-tabs-bar .v-tab--disabled {
    color: rgb(161, 161, 161) !important;
  }
  .bg {
    background-color: transparent !important;
    /* min-height: 500px; */
  }
  .v-window__container {
    min-height: 600px;
  }
  .v-window-item.v-window-item--active {
    background-color: #ffffff;
   }
  .v-window.v-item-group.theme--light.v-tabs-items {
    background-color: transparent;
  }
  .daterangepicker td.in-range {
    background-color: #93deff;
  }
  .daterangepicker td.active {
    background-color: #0086bf;
  }
  .dots-text:hover {
    background-color: rgb(230, 230, 230);
    color: blue;
  }
  @media screen and (max-width:945px) {
    .v-window__container {
      min-height: 100vh;
    }
  }
</style>
